import axios from 'axios';
import {
  ApiResponse,
  IPagination,
  INomenclature,
  IRule,
  messageType,
} from '@/types/common';

export const getNomenclature = (
  params?: IPagination
): ApiResponse<INomenclature[]> => {
  let url = 'api/nomenclature/';
  if (params) {
    url = `${url}?page=${params.page}&page_size=${params.page_size}&query=${params.query}`;
  } else {
    url = url + '?page_size=100';
  }
  return axios.get(url);
};

export const getItemsNomenclatureIds = (id: number): ApiResponse<any> => {
  return axios.get(`api/calculations/${id}/ids`);
};

export const createNomenclature = (
  params: object
): ApiResponse<INomenclature[]> => {
  return axios.post('api/nomenclature/', params);
};

export const updateNomenclature = (
  id: number,
  params: object
): ApiResponse<INomenclature> => {
  return axios.put(`api/nomenclature/${id}`, params);
};

export const deleteNomenclature = (id: number): ApiResponse<void> => {
  return axios.delete(`api/nomenclature/${id}`);
};

export const createRules = (params: object): ApiResponse<IRule> => {
  return axios.post('api/pack-rule/', params);
};

export const getRules = (params?: IPagination): ApiResponse<IRule[]> => {
  let url = 'api/pack-rule/';
  if (params) {
    url = `${url}?page=${params.page}&page_size=${params.page_size}&query=${params.query}`;
  } else {
    url = url + '?page_size=100';
  }
  return axios.get(url);
};

export const updateRule = (id: number, params: object): ApiResponse<IRule> => {
  return axios.put(`api/pack-rule/${id}`, params);
};

export const updateDefaultRule = (id: number): ApiResponse<IRule> => {
  return axios.put(`api/pack-rule/default?pack_rule_id=${id}`);
};

export const getRuleDefault = (): ApiResponse<IRule> => {
  return axios.get('api/pack-rule/default');
};

export const setRule = (id: number): ApiResponse<IRule> => {
  return axios.put('api/pack-rule/default', null, {
    params: { pack_rule_id: id },
  });
};

export const removeRule = (id: number): ApiResponse<void> => {
  return axios.delete(`api/pack-rule/${id}`);
};

export const importExcel = (params: FormData): ApiResponse<messageType> => {
  return axios.post('api/nomenclature/import', params, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const downloadFile = (): ApiResponse<Blob> => {
  return axios.get('api/nomenclature/import/example', {
    responseType: 'blob',
  });
};
